import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/components/ui/CanonicalFallback.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vitiquest-site/vitiquest-site/src/styles/index.css");
